import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { LoginResponse, IntegrationTokenPayloadInfo } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface LoginParams extends DefaultHttpHeaders {}

@Injectable()
export class LoginService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Login from MyVerti to Comeround
   * Login from MyVerti to Comeround.
   * - To make a first login it's used Basic Atuhorization with APP user. (The body will be an string encrypted)
   *
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Authentication/login
   */
  login(body: IntegrationTokenPayloadInfo, params: LoginParams): Observable<LoginResponse> {
    return this.post<IntegrationTokenPayloadInfo, LoginResponse>({
      suffix: '/authentications/login',
      body,
    });
  }
}
